'use es6';

import { ContactSearch, CrmSearch, InboundDbListSeg, ListSegClassic } from 'customer-data-filters/filterQueryFormat/strategy/StrategyTypes';
import { recordOf } from 'react-immutable-proptypes';
import Constraint from 'customer-data-filters/filterQueryFormat/logic/Constraint';
import PropTypes from 'prop-types';
export default recordOf({
  onMount: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  getField: PropTypes.func.isRequired,
  getFieldDefinitions: PropTypes.func.isRequired,
  getFieldGroups: PropTypes.func.isRequired,
  getFields: PropTypes.func.isRequired,
  getFilterFamilyOptions: PropTypes.func.isRequired,
  getOperatorsForType: PropTypes.func.isRequired,
  getListSegClassicOperatorsForType: PropTypes.func.isRequired,
  getReferenceResolvers: PropTypes.func.isRequired,
  getSpecialFieldOptions: PropTypes.func.isRequired,
  serializer: PropTypes.shape({
    toFormat: PropTypes.func.isRequired,
    fromFormat: PropTypes.func.isRequired
  }),
  serializerOptions: PropTypes.shape({
    baseFilterFamily: PropTypes.string,
    constraint: PropTypes.instanceOf(Constraint),
    enableCustomObjectSupport: PropTypes.bool,
    getAssociationTypeId: PropTypes.func,
    getAssociationCategory: PropTypes.func
  }),
  type: PropTypes.oneOf([ListSegClassic, InboundDbListSeg, ContactSearch, CrmSearch]),
  getUniqueFieldIdsByAssetFamily: PropTypes.func.isRequired
});